<template>
    <div></div>
</template>

<script>
export default {
    name: 'Disclaimer',
    data : () => ({
        visible : true,
    }),
    methods : {
        close () {
            this.visible = false;
            Cookies.set('disclaimerAccepted', 1);
        },
    },
}
</script>
